(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fooga-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fooga-mobile-purchase')) {
    customElements.define('fooga-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.select = this.querySelector('select');
        this.button = this.querySelector('.fooga-mobile-purchase__button');
        this.status = this.querySelector('[role="status"]');
        this.form = document.getElementById(this.dataset.form);
        if (!this.form) return;
        this.hidden = false;
        this.section = this.closest('.shopify-section');
        this.section?.classList.add('fooga-editorial-ready');
        this.syncAppearance();
        document.fonts?.ready.then(() => { if (this.isConnected) this.syncAppearance(); });
        const settings = { signal: this.controller.signal };
        this.mobile = matchMedia('(max-width: 999px)');
        this.colorPositions = new Map();
        this.deliveryPositions = new Map();
        this.guidePosition = null;
        this.arrangeColors = () => {
          const description = this.section.querySelector('.fooga-editorial-description');
          if (!description) return;
          if (!this.mobile.matches) {
            this.colorPositions.forEach((marker, node) => {
              if (marker.isConnected) marker.replaceWith(node);
              node.classList.remove('fooga-colors');
            });
            this.colorPositions.clear();
            this.deliveryPositions.forEach((marker, node) => {
              if (marker.isConnected) marker.replaceWith(node);
            });
            this.deliveryPositions.clear();
            if (this.guidePosition) {
              const {guide, marker} = this.guidePosition;
              if (marker.isConnected) marker.replaceWith(guide);
              guide.classList.remove('fooga-size-accordion');
              this.guidePosition = null;
            }
            return;
          }
          if (!this.guidePosition) {
            const guide = description.querySelector('accordion-disclosure');
            const firstAccordion = this.section.querySelector('.product-info__block-item[data-block-type="accordion"]');
            if (guide && firstAccordion) {
              const marker = document.createComment('');
              guide.before(marker);
              this.guidePosition = {guide, marker};
              guide.classList.add('fooga-size-accordion');
              firstAccordion.after(guide);
            }
          }
          const deliverySlot = description.querySelector('.fooga-delivery-slot');
          if (deliverySlot) this.section.querySelectorAll('[id^="ss-delivery-body-"]').forEach(body => {
            const node = body.parentElement;
            if (this.deliveryPositions.has(node)) return;
            const marker = document.createComment('');
            node.before(marker);
            this.deliveryPositions.set(node, marker);
            deliverySlot.append(node);
          });
          const colorSlot = description.querySelector('.fooga-color-slot');
          if (colorSlot) this.section.querySelectorAll('[data-fooga-product-colors], [data-block-type="product-variations"], div[class^="section-"][class*="ss_product_variant"]').forEach(node => {
            if (node.className.includes('-settings')) return;
            if (this.colorPositions.has(node)) {
              if (node.parentElement !== colorSlot) colorSlot.append(node);
              return;
            }
            const marker = document.createComment('');
            node.before(marker);
            this.colorPositions.set(node, marker);
            node.classList.add('fooga-colors');
            colorSlot.append(node);
          });
        };
        this.colorObserver = new MutationObserver(() => this.arrangeColors());
        this.colorObserver.observe(this.section, {childList: true, subtree: true});
        this.mobile.addEventListener('change', this.arrangeColors, settings);
        this.arrangeColors();
        this.barObserver = new ResizeObserver(() => document.body.style.setProperty('--fooga-bar-height', this.offsetHeight + 'px'));
        this.barObserver.observe(this);
        window.addEventListener('resize', () => this.syncAppearance(), settings);
        this.querySelectorAll('.fooga-mobile-purchase__sizes input').forEach(input => input.addEventListener('change', () => {
          this.select.value = input.value;
          this.choose();
        }, settings));
        this.querySelector('.fooga-mobile-purchase__sizes')?.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.stopPropagation();
        }, settings);
        this.select.addEventListener('change', () => this.choose(), settings);
        this.button.addEventListener('click', () => this.purchase(), settings);
        this.form.addEventListener('variant:change', event => this.sync(event.detail.variant), settings);
        this.form.addEventListener('change', event => {
          if (event.target.matches('input[data-option-position]')) this.pending();
        }, settings);
        const variantId = this.dataset.singleVariant || new URL(location.href).searchParams.get('variant');
        const initialOption = Array.from(this.select.options).find(option => option.value === variantId && !option.disabled);
        if (variantId && initialOption) {
          this.select.value = variantId;
          this.sync({ id: variantId, available: this.dataset.singleVariant ? this.dataset.singleAvailable === 'true' : initialOption.dataset.available === 'true' });
        }
      }
      syncAppearance() {
        const original = this.form.querySelector('button[type="submit"]');
        if (!original) return;
        const computed = getComputedStyle(original);
        for (const property of ['font-family', 'font-size', 'font-weight', 'font-style', 'line-height', 'letter-spacing', 'text-transform']) {
          this.style.setProperty('--fooga-' + property, computed.getPropertyValue(property));
        }
        const background = computed.getPropertyValue('--button-background').trim();
        this.style.setProperty('--fooga-control-background', background ? 'rgb(' + background + ')' : '#3e3d3f');
        const foreground = computed.getPropertyValue('--button-text-color').trim();
        this.style.setProperty('--fooga-control-color', foreground ? 'rgb(' + foreground + ')' : '#ffffff');
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.colorObserver?.disconnect();
        this.barObserver?.disconnect();
        if (this.guidePosition) {
          const {guide, marker} = this.guidePosition;
          if (marker.isConnected) marker.replaceWith(guide);
          guide.classList.remove('fooga-size-accordion');
          this.guidePosition = null;
        }
        this.deliveryPositions?.forEach((marker, node) => { if (marker.isConnected) marker.replaceWith(node); });
        this.colorPositions?.forEach((marker, node) => { if (marker.isConnected) marker.replaceWith(node); node.classList.remove('fooga-colors'); });
        document.body.style.removeProperty('--fooga-bar-height');
        this.section?.classList.remove('fooga-editorial-ready');
        clearTimeout(this.timer);
      }
      pending() {
        this.removeAttribute("data-ready");
        this.button.disabled = true;
        this.button.textContent = this.dataset.loading;
        this.status.textContent = '';
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.select.value = '';
          this.querySelectorAll('.fooga-mobile-purchase__sizes input').forEach(input => { input.checked = false; });
          this.button.disabled = false;
          this.button.textContent = this.dataset.choose;
          this.status.textContent = this.dataset.error;
        }, 12000);
      }
      choose() {
        this.removeAttribute("data-ready");
        if (!this.select.value) {
          this.button.textContent = this.dataset.choose;
          return;
        }
        const option = this.select.selectedOptions[0];
        const input = Array.from(this.form.elements).find(element => element.matches('input[data-option-position]') && element.value === option.dataset.option);
        if (!input) {
          this.status.textContent = this.dataset.error;
          this.select.value = '';
          return;
        }
        if (input.checked) {
          this.sync({ id: option.value, available: option.dataset.available === 'true' });
        } else {
          this.pending();
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      sync(variant) {
        this.syncAppearance();
        clearTimeout(this.timer);
        const option = Array.from(this.select.options).find(item => item.value === String(variant?.id));
        if (option && variant) option.dataset.available = String(Boolean(variant.available));
        this.select.value = option?.value || '';
        this.querySelectorAll('.fooga-mobile-purchase__sizes input').forEach(input => { input.checked = input.value === this.select.value; });
        if (option?.dataset.price) this.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = this.querySelector('[data-compare]');
        compare.hidden = !option?.dataset.compare;
        compare.textContent = option?.dataset.compare || '';
        this.button.disabled = Boolean(variant && !variant.available);
        this.button.textContent = variant && !variant.available ? this.dataset.soldOut : option ? this.dataset.add : this.dataset.choose;
        this.toggleAttribute('data-ready', Boolean(option && variant?.available && !option.disabled && this.form.querySelector('input[name="id"]')?.value === this.select.value));
        this.status.textContent = '';
      }
      purchase() {
        if (!this.select.value) {
          this.querySelector('.fooga-mobile-purchase__sizes input:not(:disabled)')?.focus();
          this.status.textContent = this.dataset.choose;
          return;
        }
        const currentId = this.form.querySelector('input[name="id"]')?.value;
        const submit = this.form.querySelector('button[type="submit"]');
        if (currentId !== this.select.value || !submit || submit.disabled) {
          this.status.textContent = this.dataset.error;
          return;
        }
        submit.click();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
